<template>
  <div>
    <div class="form-group redactor" :class="setPlaceholderClasses">
      <textarea :value="value" :id="'input' + _uid" class="form-control" />
      <label :for="id">{{ text }}</label>
    </div>
  </div>
</template>

<script>
import "@a/redactor/redactor.min.css";
import "@a/redactor/redactor.js";
import "@a/redactor/alignment.min.js";
import "@a/redactor/video.min.js";
import "@a/redactor/fr.js";
import placeholder from "@mixins/placeholder.js";

export default {
  name: "volcan-input-redactor",
  mixins: [placeholder],
  props: {
    text: String,
    type: String,
  },
  data: function () {
    return {
      id: null,
    };
  },
  watch: {
    value: function (newVal) {
      if (!$R("#" + this.id).editor.isFocus())
        $R("#" + this.id).source.setCode(newVal);
    },
  },
  mounted() {
    this.id = "input" + this._uid;
    var self = this;

    $R("#" + this.id, {
      linkNewTab: true,
      lang: "fr",
      imageUpload: "/api/media/uploadfilesredactor/",
      fileUpload: "/api/media/uploadfilesredactor/",
      minHeight: "300px",
      // air: true,
      toolbarFixedTopOffset: 100,
      class: "form-control",
      imageResizable: true,
      imagePosition: true,
      plugins: ["alignment", "video"],
      callbacks: {
        changed: function (html) {
          self.$emit("input", html);
        },
      },
    });
  },
  methods: {},
};
</script>
<style lang="scss">
@import "../../../Shared/Layout/Assets/sass/base/_variables.scss";

.redactor-box {
  border: 1px solid #ced4da !important;
}

.redactor-focus.redactor-styles-on,
.redactor-focus:focus.redactor-styles-on {
  border: 1px solid $primaryColor !important;
}

// .redactor-air,
// .redactor-toolbar {
// z-index: 0 !important;
//
// }
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-redactor.vue